import tokenData from '../../design-tokens/base-tokens.json';
export const MuiTabs = {
    styleOverrides: {
        root: {
            overflow: 'visible',
            alignItems: 'end'
        },
        fixed: {
            overflow: 'visible !important'
        },
        indicator: {
            display: 'none'
        },
        scroller: {
            padding: 4,
            paddingBottom: 0,
            paddingLeft: 0
        },
        flexContainer: {
            columnGap: '1.5px'
        },
        scrollButtons: ({ theme }) => ({
            border: `1px solid ${tokenData.tokens.palette.grey.grey200}`,
            padding: theme.spacing(1, 2),
            color: tokenData.tokens.palette.text.text100,
            backgroundColor: tokenData.tokens.palette.background.snow,
            maxWidth: 28,
            minHeight: 27,
            '& .MuiSvgIcon-root': {
                fontSize: 20
            },
            '&:hover': {
                backgroundColor: 'rgba(16, 116, 195, 0.04)'
            },
            '&.Mui-disabled': {
                display: 'none'
            }
        })
    }
};
export const MuiTab = {
    defaultProps: {
        disableRipple: true
    },
    styleOverrides: {
        root: ({ theme }) => ({
            textTransform: 'none',
            ...theme.typography.body1,
            minWidth: 0,
            color: tokenData.tokens.palette.text.text200,
            backgroundColor: tokenData.tokens.palette.background.snow,
            border: `1px solid ${tokenData.tokens.palette.grey.grey200}`,
            borderBottom: 'none',
            padding: theme.spacing(2, 4),
            minHeight: 'unset',
            '&.Mui-selected': {
                boxShadow: `0px -4px 0px ${tokenData.tokens.palette.blue.blue600}, 0 4px 0 -1px ${tokenData.tokens.palette.background.white}`,
                color: tokenData.tokens.palette.blue.blue500,
                backgroundColor: tokenData.tokens.palette.background.white,
                borderBottom: 'none',
                ...theme.typography.label
            },
            '&:hover': {
                '&:not(.Mui-selected)': {
                    backgroundColor: 'rgba(16, 116, 195, 0.04)'
                }
            },
            '&.Mui-focusVisible': {
                '&:not(.Mui-selected)': {
                    backgroundColor: 'rgba(16, 116, 195, 0.04)'
                },
                outline: `2px solid ${tokenData.tokens.palette.text.text300}`,
                outlineOffset: '-4px'
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                backgroundColor: tokenData.tokens.palette.background.snow
            }
        })
    }
};
